<ngx-spinner bdColor="rgba(0, 0, 0, 0.5)" [fullScreen]="true">
  <div class="custom-spinner">
    <img
      src="assets/icons/spinner-otic-2018.png"
      alt="Logo Empresa"
      class="spinner-logo"
    />
  </div>
</ngx-spinner>

<app-toasts></app-toasts>

<div class="custom-container">
  <app-header></app-header>
  <app-sidebar></app-sidebar>
  <router-outlet></router-outlet>
</div>
